import React from "react";
import { BrainIcon } from "lucide-react";
export function Footer() {
  return <footer className="bg-brand-950 px-4 pb-28 pt-10 text-center md:pb-12" data-id="element-141" data-mp="207t42eta1vo7">
      <div className="mx-auto max-w-2xl border-t border-white/10 pt-8" data-id="element-142" data-mp="209x6esbj2mmd">
        <p className="flex items-center justify-center gap-2 font-serif text-lg font-extrabold text-white" data-id="element-143" data-mp="2f4bie8wocvrj">
          <BrainIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-144" data-mp="2a6ianbfq3tp5" /> Sensory Decision Map™
        </p>
        <p className="mt-3 text-sm text-brand-100" data-id="element-145" data-mp="1me1tr47q27rf">© 2026 · Sensory Decision Map™ · All rights reserved.</p>
        <p className="mt-3 text-xs leading-relaxed text-brand-200" data-id="element-146" data-mp="1heyqnpbaybm3">
          Educational resource for Occupational Therapists and Occupational Therapy students. Not a substitute for
          professional judgment, standardized assessment training, certification, diagnosis, or individualized clinical care.
        </p>
      </div>
    </footer>;
}